// extracted by mini-css-extract-plugin
export var container = "_dc-0";
export var popoverContent = "_dc-1";
export var tosLink = "_dc-2";